package com.vizio.redwolf.auth.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

data class AccountAuthCodeRequestInfo(
    val accessToken: String,
    val clientId: String,
    val redirectUri: String,
    val state: String
)

@Serializable
data class AccountAuthCodeRequestBody(
    @SerialName("clientId") val clientId: String,
    @SerialName("redirectUri") val redirectUri: String,
    @SerialName("state") val state: String
)
